const prompts = [
    "Write about a memory you can't fully trust.",
    "Imagine the smell of a season you've never experienced.",
    "Describe a moment when silence felt louder than words.",
    "What's the shape of regret? Let it sing.",
    "Revisit an ordinary conversation that changed your life.",
    "Capture the feeling of being late for something that no longer matters.",
    "What would a bird think of your happiest memory?",
    "Describe the sound of something breaking—slowly.",
    "Write about a dream you haven't had yet.",
    "What's hiding in the gap between two goodbyes?",
    "Take a childhood fear and make it a hero.",
    "Write about a day when everything seemed upside down but no one noticed.",
    "Imagine forgetting something important. What remains?",
    "What color was the sky when you first felt alive?",
    "Write about the last time you lied to yourself.",
    "What's the texture of a memory you're trying to bury?",
    "Write as though you're whispering to someone who isn't there.",
    "What's the taste of an unfinished apology?",
    "Turn an argument into a map. Where does it lead?",
    "Describe your reflection if the mirror told the truth.",
    "What would your shadow say about you?",
    "Write about a moment you were seen—but didn't want to be.",
    "How does joy behave when it thinks no one's watching?",
    "Write about the weight of an ordinary object.",
    "What song does the moon hum when no one's awake?",
    "Describe the first time you realized the world isn't fair.",
    "Imagine laughter as something tangible—what would you do with it?",
    "What's the echo of something you've lost?",
    "Write about the first time you truly felt the weather.",
    "Take a piece of advice you never followed. Write its story.",
    "What does your name taste like to someone who's never spoken it?",
    "Describe the sound of an unanswered question.",
    "Write about a time when your favorite song betrayed you.",
    "How does loneliness change the shape of a room?",
    "What's the melody of a secret you've kept for years?",
    "Write about a stranger you'll never meet again.",
    "What would happen if your happiest memory were rewritten?",
    "Describe the way light moves when no one's around to see it.",
    "Write about the moment before you knew what would happen.",
    "What's the rhythm of someone walking away?",
    "How would your favorite place apologize for changing?",
    "What's the sound of holding back tears?",
    "Write about an apology you never gave.",
    "How does time feel in your hands?",
    "Describe the first time you forgot something important.",
    "What's the chorus of a goodbye you never said?",
    "Imagine your favorite memory is a movie—write the end credits.",
    "Write about the way a place remembers you.",
    "What's the sound of something you can't forgive?",
    "Describe how the wind feels when it's carrying someone else's story.",
    "Write about a smile that felt like a trap.",
    "What's the sound of a conversation ending too soon?",
    "Describe a relationship as though it were a piece of furniture.",
    "Write about the space between holding hands and letting go.",
    "What's the texture of a goodbye you didn't believe?",
    "Imagine two people who are mirrors for each other. What do they see?",
    "Write about the first time someone's laugh felt like home.",
    "What would a misunderstanding look like if it were alive?",
    "Describe the way someone's voice changed when they stopped caring.",
    "Write about a moment when a hug felt heavier than words.",
    "How does betrayal move through the air?",
    "What's the taste of an unspoken truth between two people?",
    "Imagine a relationship as a staircase—where does it lead?",
    "Write about a love that never quite fit.",
    "Describe the shadow of someone you miss.",
    "What's the sound of a fight that isn't over?",
    "Write about a secret you shared but wish you hadn't.",
    "What does forgiveness smell like?",
    "Write about a moment when a glance said everything.",
    "What's the shape of a promise you couldn't keep?",
    "Describe the way someone's absence feels in a crowded room.",
    "Write about the rhythm of a relationship that stopped working.",
    "What does longing look like when it thinks no one's watching?",
    "Write about a time when words weren't enough.",
    "How does love behave when it's trying to hide?",
    "Describe a relationship as though it were a river. Where does it flow?",
    "What's the melody of two people who've drifted apart?",
    "Write about a moment when you felt replaced.",
    "What does a shared secret sound like from a distance?",
    "Imagine a friendship as a plant—describe how it grows.",
    "What's the taste of a conversation you regret?",
    "Write about the silence that lingers after an argument.",
    "Describe a relationship that felt like a puzzle with missing pieces.",
    "What does affection feel like when it's unspoken?",
    "Write about a laugh you haven't heard in years.",
    "What's the weight of a memory two people share but don't talk about?",
    "Imagine a phone call that never happened—what was said?",
    "Write about a relationship as though it were a piece of music.",
    "What's the sound of someone walking away without looking back?",
    "Describe the feeling of being known too well.",
    "Write about a time when a compliment felt like a lie.",
    "What does a goodbye sound like when it's meant forever?",
    "Imagine two people who are oceans apart—what connects them?",
    "Write about the way someone's presence changes a room.",
    "What's the rhythm of a relationship that never quite began?",
    "Describe a moment when someone's kindness caught you off guard.",
    "Write about the taste of a relationship that's gone sour.",
    "What does regret feel like when it belongs to someone else?",
    "Imagine a relationship as a storm—what's the aftermath?",
    "Write about a moment when you couldn't say what needed to be said.",
    "Write about the first time you felt out of place in a crowd.",
    "What's the sound of trying to blend in?",
    "Describe a moment when you felt invisible and powerful at the same time.",
    "What's the shape of responsibility as you carry it?",
    "Write about a time when the rules didn't make sense to you.",
    "How does ambition feel in your hands?",
    "Imagine your role in society as a thread in a larger fabric—what color is it?",
    "What's the rhythm of a system you don't understand?",
    "Write about the weight of expectations that weren't yours to carry.",
    "What does a small act of rebellion taste like?",
    "Describe the sound of your voice among many others.",
    "Write about a time when you questioned your purpose.",
    "What's the melody of being overlooked?",
    "Imagine your job as a dance—how do you move?",
    "Write about a moment when you felt like a cog in a machine.",
    "What does respect look like when it's worn thin?",
    "Describe the feeling of contributing to something larger than yourself.",
    "What's the taste of compromise in the name of survival?",
    "Write about the sound of a paycheck hitting your hands.",
    "Imagine being a pillar in a crumbling structure—how do you hold up?",
    "What's the texture of obligation?",
    "Describe a moment when you felt like a stranger in your own city.",
    "What does hope sound like when it's shared by many?",
    "Write about a role you didn't choose but took on anyway.",
    "What's the rhythm of fitting in where you don't belong?",
    "Imagine your life as a book—what's the title society would give it?",
    "Write about a moment when you stood up for something you believed in.",
    "What does success feel like when it doesn't look like you imagined?",
    "Describe the weight of an unspoken expectation.",
    "Write about the sound of marching forward even when you don't agree.",
    "What's the melody of holding a sign in protest?",
    "Imagine your role in society as a clock—how do you tick?",
    "Write about a moment when you felt like you were just going through the motions.",
    "What does responsibility smell like when it's left undone?",
    "Describe the feeling of being a small part of something enormous.",
    "What's the texture of a system that doesn't see you?",
    "Write about a moment when you felt your contribution wasn't enough.",
    "Imagine your role in society as a tree—what kind of tree are you?",
    "What does sacrifice feel like when it's unnoticed?",
    "Write about the rhythm of working to live rather than living to work.",
    "Describe the sound of stepping out of line.",
    "What's the weight of following rules that don't feel fair?",
    "Write about a moment when you felt judged by strangers.",
    "What's the melody of a system you want to change?",
    "Imagine being the bridge between two sides—what does that feel like?",
    "Write about the feeling of being both celebrated and misunderstood.",
    "What does progress sound like when it moves too slowly?",
    "Describe a moment when you felt like you belonged and didn't at the same time.",
    "What's the taste of conformity?",
    "Write about the sound of your role shifting in an unsteady world.",
    "What would Earth write in a letter to humanity?",
    "Describe the first sunrise as seen by humankind.",
    "What's the sound of progress when it costs too much?",
    "Imagine the collective heartbeat of humanity—what does it feel like?",
    "Write about the weight of history on the shoulders of the present.",
    "What's the melody of hope when it spans generations?",
    "Describe humanity's shadow—what does it look like?",
    "What would the stars say if they could speak?",
    "Write about a moment when humanity seemed like one person.",
    "What's the taste of a world rebuilding itself?",
    "Imagine the song of a future humanity.",
    "What does the planet sound like when it's sighing?",
    "Write about the first handshake between two worlds.",
    "What's the color of humanity's dreams?",
    "Describe the echo of human voices in an empty space.",
    "What does kindness look like when multiplied by billions?",
    "Write about the way we leave marks on the world.",
    "What's the sound of forgiveness when it spans the entire species?",
    "Imagine humanity as a tree—how do its branches grow?",
    "Write about the way humanity sees itself in the mirror.",
    "What would a river say about the humans it's carried?",
    "Describe the first time someone looked at the moon and wondered.",
    "What's the rhythm of innovation and destruction?",
    "Write about humanity as though it were a single person.",
    "What does love look like on a global scale?",
    "Imagine humanity's collective memory as a library—what's missing?",
    "What's the sound of a billion people dreaming at once?",
    "Write about the balance between creation and consumption.",
    "Describe the first moment someone realized they weren't alone.",
    "What does the Earth feel like when it's forgotten?",
    "Write about humanity's relationship with time.",
    "What's the taste of a shared meal that spans cultures?",
    "Describe the way humans find meaning in the stars.",
    "What's the melody of a planet on the brink of change?",
    "Write about humanity's relationship with its own reflection.",
    "What does survival sound like when it's a global effort?",
    "Imagine the collective grief of the world—what does it say?",
    "Write about a moment when humanity overcame its differences.",
    "What's the color of understanding between strangers?",
    "Describe the way humanity would introduce itself to the universe.",
    "What's the sound of the first footstep on an untouched world?",
    "Write about the way humanity remembers its mistakes.",
    "What does the future look like when it smiles back?",
    "Imagine the Earth as a canvas—what does humanity paint?",
    "What's the rhythm of rebuilding what was once lost?",
    "Write about the shared experience of looking up at the sky.",
    "What does compassion sound like on a planetary scale?",
    "Describe humanity's place in the infinite.",
    "What's the melody of the first song sung by every culture?",
    "Write about the way humanity holds onto hope.",
    "What would a cat say if it could text?",
    "Describe a day in the life of a professional procrastinator.",
    "What's the secret life of a sock that goes missing in the laundry?",
    "Write about a world where everyone communicates through dance.",
    "What's the story behind the last slice of pizza?",
    "Describe the adventures of a rubber duck in a bathtub.",
    "What would happen if gravity took a day off?",
    "Write about a conversation between a toaster and a refrigerator.",
    "What's the most ridiculous conspiracy theory you can think of?",
    "Describe a day where everything you touch turns into cheese.",
    "What's the plot of a soap opera starring houseplants?",
    "Write about a superhero whose power is extreme laziness.",
    "What would a dog's diary entry look like?",
    "Describe a world where everyone has to rhyme when they speak.",
    "What's the most absurd law you can imagine?",
    "Write about a day in the life of a professional napper.",
    "What's the story behind a mysterious rubber chicken?",
    "Describe a world where everyone has to wear mismatched shoes.",
    "What would happen if all the clocks in the world stopped?",
    "Write about a conversation between a pencil and an eraser.",
    "What's the most bizarre dream you've ever had?",
    "Describe a world where everyone has to sing instead of talk.",
    "What's the plot of a reality show starring garden gnomes?",
    "Write about a day where everyone can read each other's thoughts.",
    "What would happen if the internet disappeared for a week?",
    "Describe a world where everyone has to wear a hat at all times.",
    "What's the story behind a haunted coffee mug?",
    "Write about a conversation between a cloud and a rainbow.",
    "What would happen if animals could vote?",
    "Describe a world where everyone has to walk backwards.",
    "What's the most ridiculous invention you can think of?",
    "Write about a day in the life of a professional bubble blower.",
    "What's the story behind a mysterious pair of sunglasses?",
    "Describe a world where everyone has to wear pajamas all day.",
    "What would happen if all the books in the world disappeared?",
    "Write about a conversation between a spoon and a fork.",
    "What's the most absurd talent show act you can imagine?",
    "Describe a world where everyone has to wear roller skates.",
    "What would happen if all the colors in the world changed?",
    "Write about a day where everyone can only speak in questions.",
    "What's the story behind a mysterious key with no lock?",
    "Describe a world where everyone has to wear a costume every day.",
    "What would happen if all the mirrors in the world disappeared?",
    "Write about a conversation between a lamp and a chair.",
    "What's the most bizarre holiday you can think of?",
    "Describe a world where everyone has to wear sunglasses indoors.",
    "What would happen if all the music in the world stopped?",
    "Write about a day in the life of a professional daydreamer.",
    "What's the story behind a mysterious old photograph?",
    "Describe a world where everyone has to wear mismatched socks."
];

export default prompts;